<template>
  <brand-aggregate-page
    storage-key="foodBrandListData"
    default-title="餐饮自提"
    empty-icon="🍿"
  />
</template>

<script>
import BrandAggregatePage from './BrandAggregatePage.vue';

export default {
  name: 'FoodBrandList',
  components: { BrandAggregatePage },
};
</script>
